import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";

import CandidatePageWrapper from "candidate/CandidatePageWrapper";
import { ErrorIcon } from "common/DS/Icons";
import { Body1 } from "common/DS/Text";
import ZeroState from "common/DS/ZeroState";
import LanguageSelector from "common/LanguageSelector";

type ErrorHelperTextProps = {
    errorText?: string;
    companyName?: string;
};

const ErrorHelperText = (
    { errorText = "", companyName = "" }: ErrorHelperTextProps,
    { t: _ }: { t: (s: string, c: object) => string },
) => {
    const errorDescription = errorText || "An error has occurred.";
    const companyDisplayName = companyName !== "" ? companyName : "your employer";
    const endText = (
        <>
            <p>{errorDescription}</p>
            <p>
                {_("Please contact {company} if you think this is a mistake.", {
                    company: companyDisplayName,
                })}
            </p>
        </>
    );
    return <Body1>{endText}</Body1>;
};

ErrorHelperText.contextTypes = {
    t: PropTypes.func,
};

const ErrorStateIcon = <ErrorIcon />;

type ErrorStateProps = {
    errorTitle?: string;
    errorText?: string;
    companyName?: string;
    showLanguageSelector?: boolean;
    errorIcon?: React.ReactNode;
    className?: string;
};

export const ErrorState = ({
    errorTitle = "Page not found",
    errorText = "",
    companyName = "",
    showLanguageSelector = true,
    errorIcon = ErrorStateIcon,
    className = "",
}: ErrorStateProps) => {
    const internalClassName = classNames("elevation-one", `${className}`);
    return (
        <>
            <ZeroState
                icon={errorIcon}
                title={errorTitle}
                helperTextComponent={
                    <ErrorHelperText errorText={errorText} companyName={companyName} />
                }
                padding="xxl"
                additionalClassName={internalClassName}
            />
            {showLanguageSelector && <LanguageSelector />}
        </>
    );
};
type ErrorPageProps = ErrorStateProps & {
    wrapperClass?: string;
};

export const ErrorPage = ({
    wrapperClass = "zero-state__wrapper",
    errorTitle = "Page not found",
    errorText = "",
    companyName = "",
    showLanguageSelector = true,
    errorIcon = ErrorStateIcon,
    className = "",
}: ErrorPageProps) => (
    <CandidatePageWrapper contentClassName={wrapperClass} showFooter={false}>
        <ErrorState
            errorTitle={errorTitle}
            errorText={errorText}
            companyName={companyName}
            showLanguageSelector={showLanguageSelector}
            errorIcon={errorIcon}
            className={className}
        />
    </CandidatePageWrapper>
);
